import React from "react";
import { List } from "../modules/ReimbursementsApprovals";

export function ReimbursementsList(props) {
  return <List {...props} />;
}
